import React, { HTMLProps } from "react";
import cn from "classnames";
import s from "../FilterPage.module.scss";

const Body = ({ className, ...props }: HTMLProps<HTMLDivElement>) => (
  <div {...props} className={cn(className, s.body)} />
);

export default Body;
